import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import cn from 'clsx';
import React from 'react';
import css from 'styled-jsx/css';
import withI18next from '~/../hocs/_withI18next';
import Config from '~/config';
import themeVariables from '~/shared/themeVariables';
import IconEdit from '~/components/svg/icon-edit.svg';
import IconEditActive from '~/components/svg/icon-edit-active.svg';

const iconEdit = css.resolve`
   {
    margin-right: 8px;
  }
`;

@withI18next()
class ButtonEdit extends React.PureComponent {
  render() {
    const { className, onClick, t, loading } = this.props;
    const buttonClassName = cn(
      'btn',
      `btn-${Config.serviceType}`,
      'btn-block btn-edit',
      className,
    );

    return (
      <div>
        <button type="button" className={buttonClassName} onClick={onClick}>
          {loading ? (
            <FontAwesomeIcon
              style={{ width: '1em' }}
              icon={faSpinner}
              pulse
              className={iconEdit.className}
            />
          ) : (
            <>
              <IconEdit
                className="icon-edit"
                width="20"
                style={{ marginRight: 16 }}
              />
              <IconEditActive
                className="icon-edit-active"
                width="20"
                style={{ marginRight: 16 }}
              />
            </>
          )}
          {t('edit')}
        </button>
        {/* {isFreeUser && (
          <p className="btn-edit-note">( {t('edit_button_note')} )</p>
        )} */}
        {iconEdit.styles}
        <style jsx>
          {`
            .btn-edit {
              margin-top: 16px;
              height: 48px;
              font-size: 16px;
              border-radius: 4px;
              font-weight: 600;
              background: #fff;
              border: 2px solid ${themeVariables.colors.bodyText};
              color: ${themeVariables.colors.bodyText};
            }
            .btn-edit:hover {
              color: #fff;
              background: ${themeVariables.colors.bodyText};
            }
            .btn-edit-note {
              margin-bottom: 7px;
              text-align: center;
            }
          `}
        </style>
        <style jsx global>
          {`
            .btn-edit:hover .icon-edit,
            .btn-edit .icon-edit-active {
              display: none;
            }
            .btn-edit .icon-edit,
            .btn-edit:hover .icon-edit-active {
              display: initial;
            }
          `}
        </style>
      </div>
    );
  }
}

export default ButtonEdit;
